import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "projects",
  "use": "projects-usage",
  "viewBox": "0 0 101.26 81.07",
  "content": "<symbol viewBox=\"0 0 101.26 81.07\" id=\"projects\"><path d=\"M93.22 4.05c-.57-2.23-3.33-4-6.13-4H14.17C11.36 0 8.61 1.82 8 4.05l-1 6.08h87.2l-1-6.08zm5.1 11.15H2.94A2.94 2.94 0 0 0 0 18.42l4.69 59.12a3.9 3.9 0 0 0 3.88 3.53h84.12a3.91 3.91 0 0 0 3.88-3.53l4.67-59.12a2.93 2.93 0 0 0-2.92-3.22z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/projects.svg
// module id = dNc7
// module chunks = 1